import { Button, Drawer, Empty, Loading, Title } from "@components";
import { useEffect, useState } from "react";
import { ForEach, If } from "shared/components/control-statements";
import { InputSearch } from "shared/components/InputSearch";
import styles from "styles/pages/cdp/database-management.module.scss";
import { v4 as uuid } from "uuid";
import CreateGroup from "../CreateGroup";
import Groups from "../Groups";
import MoveItems from "../MoveVariable";
import Variable from "../Variable";

export default function SourceFolder() {
  const [loading, setLoading] = useState(true);
  const [group, setGroup] = useState({});
  const [openGroup, setOpenGroup] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [groups, setGroups] = useState([]);
  const [openCreateGroup, setOpenCreateGroup] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      setLoading(false);
    };

    fetch();
  }, []);

  if (loading) return <Loading fullContent />;

  const filteredResults = results.filter((c) => {
    return !!search ? c?.toLowerCase().includes(search.toLowerCase()) : true;
  });

  const createGroup = async (group) => {
    setGroups((prev) => [
      ...prev,
      {
        id: uuid(),
        name: group.name,
      },
    ]);

    setSelectedItems([]);
  };

  return (
    <>
      <Title
        title={group.name || "Origem"}
        backTo={{ url: "/cdp/tratamento-de-base/origem", name: "Origem" }}
      >
        <InputSearch
          placeholder="Buscar por..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </Title>

      <If cond={(filteredResults || []).length > 0 && !loading}>
        <div className={styles.results}>
          <ForEach
            items={filteredResults}
            render={(r) => {
              return (
                <Variable
                  key={r}
                  item={r}
                  onSelect={() =>
                    setSelectedItems((prev) =>
                      prev.includes(r)
                        ? prev.filter((id) => id !== r)
                        : [...prev, r]
                    )
                  }
                  icon={<i className="fal fa-arrow-progress" />}
                  selectedItems={selectedItems}
                />
              );
            }}
          />
        </div>
      </If>

      <If cond={(filteredResults || []).length === 0 && !loading}>
        <Empty>
          <i className="fal fa-arrow-progress" />
          <p>Nenhum registro encontrado.</p>
        </Empty>
      </If>

      <If cond={(selectedItems || []).length > 0}>
        <MoveItems
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          openGroup={() => setOpenGroup(true)}
          openRemove={() => setOpenRemove(true)}
        />
      </If>

      <Groups
        visible={openGroup}
        onClose={() => setOpenGroup(false)}
        onSave={() => {
          setSelectedItems([]);
        }}
        groups={groups}
        variableName="Origem"
        openCreateGroup={() => setOpenCreateGroup(true)}
      />

      <CreateGroup
        visible={openCreateGroup}
        onClose={() => setOpenCreateGroup(false)}
        onCreateGroup={(group) => createGroup(group)}
      />

      <Drawer
        visible={openRemove}
        onClose={() => setOpenRemove(false)}
        direction="center"
        title="Remover variável"
        showCloseButton={false}
      >
        <div className={styles.removeContainer}>
          <p className={styles.message}>
            Você tem certeza que deseja remover a variável{" "}
            {`${group.name ? `"${group.name}"` : ""}`} deste grupo?
          </p>

          <div className={styles.actions}>
            <Button
              design="primary"
              onClick={() => {
                setOpenRemove(false);
              }}
              className="w-100"
            >
              Remover
            </Button>
            <Button className="w-100" onClick={() => setOpenRemove(false)}>
              Cancelar
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}
